import { defineElement, FC, onDidLoad, useElement, useListen } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { debounce } from '@bpd-library/utilities';
import { BPDFormElement, validateField } from '@source/components/atoms';
import { openModal } from '@source/store/modals';
import { AreaProjectNewsletterProps } from '@store/subscription/services/api-calls';
import { subscribeToAreaProject } from '@store/subscription/store';
import Cookies from 'js-cookie';

const CLASS_EXPANDED_SIGNUP = 'area-subscription-de--expanded-signup';
const COOKIE_NAME = 'BPD::SubscribedToAreaProjectGermany';

const AreaSubscriptionDe: FC = ({ element }) => {
    const form = useElement<BPDFormElement>('[js-hook-area-subscription-de-form]');
    const emailInput = useElement<HTMLInputElement>('[js-hook-area-subscription-de-email]');

    onDidLoad(() => {
        if (isSubscribed()) {
            setSubscribedMessage();
        }
    });

    useListen(emailInput, 'keyup', debounce(expand, 300));
    useListen(form, 'serializedForm', async (e: any) => {
        const { email, salutation, firstname, lastname } = e.detail;
        const {districtId, areaId, areaProjectName} = window.__ENVIRONMENT_DETAILS__;

        const data: AreaProjectNewsletterProps = {
            areaInfo: {
                areaProjectId: areaId,
                areaProjectName: areaProjectName,
                ...(districtId && {districtId})
            },
            userInfo: {
                email,
                firstName: firstname,
                lastName: lastname,
                gender: salutation,
            },
        };

        await subscribeToAreaProject(data);
        setIsSubscribedCookie();
        setSubscribedMessage();
        openModal('area-subscription-de');
    });

    function expand() {
        const emailIsValid =
            emailInput.current?.value &&
            validateField(emailInput.current.value, 'email').length === 0;

        if (emailIsValid) {
            element.classList.add(CLASS_EXPANDED_SIGNUP);
        } else {
            element.classList.remove(CLASS_EXPANDED_SIGNUP);
        }
    }

    function isSubscribed() {
        return !!Cookies.get(COOKIE_NAME);
    }

    function setIsSubscribedCookie() {
        const aYearFromNow = new Date();
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);

        Cookies.set(COOKIE_NAME, 'true', {
            expires: aYearFromNow,
        });
    }

    function setSubscribedMessage() {
        element.innerHTML = '';
        element.append(
            <div class="area-subscription-de__heading u-color--white u-text--centered">
                <p class="u-subtitle-2 u-h4--md">Sie sind bereits für den Newsletter registriert</p>
                <p class="area-subscription-de__subtitle">
                    Wir informieren Sie regelmäßig per E-Mail über die wichtigsten Neuigkeiten
                </p>
            </div>,
        );
    }
};

defineElement('area-subscription-de', AreaSubscriptionDe);
